import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import CenterDetailPage from './pages/CenterDetailPage';
import CategoryPage from './pages/CategoryPage';
import ProvincePage from './pages/ProvincePage';

function App() {
    return (
        <Layout>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/centro/:id" element={<CenterDetailPage />} />
                <Route path="/categoria/:category" element={<CategoryPage />} />
                <Route path="/provincia/:province" element={<ProvincePage />} />
                <Route path="/buscar" element={<HomePage />} />
            </Routes>
        </Layout>
    );
}

export default App;